// Sport-agnostic game configuration for FantasyPRIME

// Supply limits per rarity per player (shared across all sports).
//
// MIRROR of apps/nextjs src/config/game.config.ts MAX_SUPPLY_PER_PLAYER — keep
// in sync. jest-client cannot import nextjs source, so these literals are a
// deliberate copy of the canonical table (500/200/75/32/13); the nextjs test
// src/config/game.config.test.ts pins those values so any change is deliberate
// and must be applied here (and in src/types/index.ts RARITY_CONFIG) too.
export const RARITY_SUPPLY = {
  PROSPECT: 500,
  ROOKIE: 200,
  VETERAN: 75,
  ALL_STAR: 32,
  GOAT: 13,
} as const;

// Rarity colors for cards (shared across all sports)
// Prospect=Silver, Rookie=Sapphire, Veteran=Ruby, All-Star=Emerald, GOAT=Gold
export const RARITY_COLORS = {
  PROSPECT: {
    bg: 'bg-[#9BA3AF]/20',
    text: 'text-[#9BA3AF]',
    border: 'border-[#9BA3AF]/50',
    gradient: 'from-[#9BA3AF]/60 to-[#9BA3AF]/30',
    glow: 'shadow-[#9BA3AF]/20',
  },
  ROOKIE: {
    bg: 'bg-[#2563EB]/20',
    text: 'text-[#2563EB]',
    border: 'border-[#2563EB]/50',
    gradient: 'from-[#2563EB]/80 to-[#2563EB]',
    glow: 'shadow-[#2563EB]/30',
  },
  VETERAN: {
    bg: 'bg-[#DC2626]/20',
    text: 'text-[#DC2626]',
    border: 'border-[#DC2626]/50',
    gradient: 'from-[#DC2626]/80 to-[#DC2626]',
    glow: 'shadow-[#DC2626]/40',
  },
  ALL_STAR: {
    bg: 'bg-[#059669]/20',
    text: 'text-[#059669]',
    border: 'border-[#059669]/50',
    gradient: 'from-[#059669]/80 to-[#059669]',
    glow: 'shadow-[#059669]/40',
  },
  GOAT: {
    bg: 'bg-gold/20',
    text: 'text-gold',
    border: 'border-gold/50',
    gradient: 'from-gold to-gold-hover',
    glow: 'shadow-gold/60',
  },
} as const;

// Currency configuration
export const CURRENCY_CONFIG = {
  startingCoins: 1000,
  startingGems: 0,
  coinIcon: 'Coins',
  gemIcon: 'Gem',
} as const;
